export default "__VITE_ASSET__BBeihOOc__"